/*
	sri-toolbox
*/

module.exports = {
  generate: require("./generate")
};